













































































































































































































































































































































import axios from 'axios';
import { cloneDeep, get, unescape, isEqual } from 'lodash';
import CoCard from '@/components/Molecules/co-card/CoCard.vue';
import CoImage from '@/components/Atoms/co-image/CoImage.vue';
import CoRoundButton from '@/components/Atoms/co-round-button/CoRoundButton.vue';
import CoButton from '@/components/Atoms/co-button/CoButton.vue';
import CoSlider from '@/components/Molecules/co-slider/CoSlider.vue';
import CoEditor from '@/components/Molecules/co-editor/CoEditor.vue';
import CoConfirmation from '@/components/Molecules/co-confirmation/CoConfirmation.vue';
import CoDragDropFileUpload from '@/components/Organisms/co-drag-drop-file-upload/CoDragDropFileUpload.vue';
import CoThumbnail from '@/components/Molecules/co-thumbnail/CoThumbnail.vue';
import CoDropdown from '@/components/Molecules/co-dropdown/CoDropdown.vue';
import CoDropdownItem from '@/components/Molecules/co-dropdown-item/CoDropdownItem.vue';
import EventBus from '@/eventBus';
import CoAlert from '@/components/Molecules/co-alert/CoAlert.vue';
import CoCheckbox from '@/components/Atoms/co-checkbox/CoCheckbox.vue';
import CoIcon from '@/components/Atoms/co-icon/CoIcon.vue';
import CoLabel from '@/components/Atoms/co-label/CoLabel.vue';
import CoInput from '@/components/Molecules/co-input/CoInput.vue';
import CoFormGroup from '@/components/Molecules/co-form-group/CoFormGroup.vue';
import CoEditorContent from '@/components/Molecules/co-editor-content/CoEditorContent.vue';
import CoText from '@/components/Atoms/co-text/CoText.vue';
import CoVideoEmbed from '@/components/Molecules/co-video-embed/CoVideoEmbed.vue';
import CoAudioEmbed from '@/components/Molecules/co-audio-embed/CoAudioEmbed.vue';
import { SUPPORTED_IMAGE_ACCEPT } from '@/constants/fileUpload';
import { createImageUploadFormData } from '@/utils/imageUpload';
import { getAudioProvider, isValidAudioUrl, isValidVideoUrl, normalizeMediaUrl } from '@/utils/video';

export default {
    name: 'CoContentSection',
    components: {
        CoCard,
        CoImage,
        CoRoundButton,
        CoSlider,
        CoEditor,
        CoButton,
        CoConfirmation,
        CoDragDropFileUpload,
        CoThumbnail,
        CoDropdown,
        CoDropdownItem,
        CoAlert,
        CoLabel,
        CoCheckbox,
        CoIcon,
        CoInput,
        CoFormGroup,
        CoEditorContent,
        CoText,
        CoVideoEmbed,
        CoAudioEmbed,
    },
    props: {
        value: {
            type: Object,
            required: true,
        },
        canIEdit: {
            type: Boolean,
            default: false,
        },
        disableMoveUp: {
            type: Boolean,
            default: false,
        },
        disableMoveDown: {
            type: Boolean,
            default: false,
        },
        me: {
            type: Object,
            default: null,
        },
        cardVariant: {
            type: String,
            default: null,
        },
        hasPremiumAccess: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            isEditMode: false,
            content: {},
            originalContent: {},

            candidateImages: [], // {preview, file}
            loading: false,
            canISave: false,
            // MediaKind distinguishes a new empty editor and is removed before persistence.
            mediaKind:
                Boolean(getAudioProvider(this.value?.Content)) || this.value?.MediaKind === 'audio' ? 'audio' : 'video',
            meLocal: this.me || this.$store?.state?.me,
            // code options utility
            aspectratio: this.value?.Options?.aspectratio || 'landscape',
            backgroundcolor: this.value?.Options?.backgroundcolor || '#ffffff',
            imageAccept: SUPPORTED_IMAGE_ACCEPT,
        };
    },
    watch: {
        value: {
            handler(newValue, oldValue) {
                // Media edits use a local copy so Discard cannot leave the parent section URL mutated.
                this.content = newValue?.Type === 3 ? cloneDeep(newValue) : newValue;
                if (newValue !== oldValue) {
                    this.originalContent = newValue ? cloneDeep(newValue) : null;
                    this.mediaKind =
                        Boolean(getAudioProvider(newValue?.Content)) || newValue?.MediaKind === 'audio'
                            ? 'audio'
                            : 'video';
                }
                if (this.content?.StartEditMode) {
                    this.isEditMode = true;
                    this.focusMediaInput();
                }
            },
            deep: true,
        },
        content: {
            handler() {
                this.canISave = !isEqual(this.content, this.originalContent);
                if (this.content && this.content.Type === 1) {
                    this.canISave = this.candidateImages.length > 0 || this.content.Images.length > 0;
                }
                if (this.content && this.content.Type === 3) {
                    this.canISave =
                        (this.isAudioSection
                            ? isValidAudioUrl(this.content.Content)
                            : isValidVideoUrl(this.content.Content)) && !isEqual(this.content, this.originalContent);
                }
            },
            deep: true,
        },
        candidateImages: {
            handler() {
                if (this.content && this.content.Type === 1) {
                    this.canISave = this.candidateImages.length > 0 || this.content.Images.length > 0;
                }
            },
            deep: true,
        },
        aspectratio(val) {
            if (this.content) {
                this.content.Options = {
                    ...this.content?.Options,
                    aspectratio: val,
                };
                this.canISave = true;
            }
        },
        backgroundcolor(val) {
            if (this.content) {
                this.content.Options = {
                    ...this.content?.Options,
                    backgroundcolor: val,
                };
                this.canISave = true;
            }
        },
    },
    computed: {
        isAudioSection() {
            return this.mediaKind === 'audio';
        },
        isPaywallSection() {
            return this.content && this.content.Type === 4;
        },
        amIAdmin() {
            return get(this.meLocal, 'Permissions', '').includes('space_admin');
        },
        supportsInlineEditing() {
            return this.content?.Type !== 4;
        },
        showEditButton() {
            if (this.isPaywallSection) {
                return false;
            }
            return this.supportsInlineEditing;
        },
        showPaywallPreview() {
            return this.content?.Type === 4 && !this.canIEdit;
        },
        // Use a reassurance label when the viewer already has access to the premium section.
        paywallLabelKey() {
            return this.hasPremiumAccess ? 'labels.premiumAccessIncludedInYourPlan' : 'labels.paidAccessStartsHere';
        },
    },
    created() {
        this.content = this.value?.Type === 3 ? cloneDeep(this.value) : this.value;
        if (this.content?.StartEditMode) {
            this.isEditMode = true;
        }
    },
    mounted() {
        this.originalContent = this.value ? cloneDeep(this.value) : null;
        if (this.content?.Type === 3 && this.isEditMode) {
            this.focusMediaInput();
        }
    },
    methods: {
        get,
        unescape,
        isValidAudioUrl,
        isValidVideoUrl,
        focusMediaInput() {
            this.$nextTick(() => {
                // Wait for dropdown closing and card layout before moving the focused input into view.
                window.requestAnimationFrame(() => {
                    const input = this.$refs.mediaUrlInput;
                    if (!input) {
                        return;
                    }

                    input.focus();
                    const nativeInput = input.$refs?.coInputElem;
                    if (nativeInput && typeof nativeInput.scrollIntoView === 'function') {
                        nativeInput.scrollIntoView({
                            block: 'center',
                            inline: 'nearest',
                        });
                    }
                });
            });
        },
        removeImage(index: number, cadidate = false) {
            if (cadidate) {
                this.candidateImages.splice(index, 1);
                return;
            }
            this.content.Images.splice(index, 1);
        },
        async save() {
            this.loading = true;
            if (this.content.Type === 3) {
                const isValidUrl = this.isAudioSection
                    ? isValidAudioUrl(this.content.Content)
                    : isValidVideoUrl(this.content.Content);
                if (!isValidUrl) {
                    this.loading = false;
                    return;
                }

                // Persist only the canonical provider URL; oEmbed data remains presentation-only.
                this.content.Content = normalizeMediaUrl(this.content.Content);
                if (Object.prototype.hasOwnProperty.call(this.content, 'StartEditMode')) {
                    this.$delete(this.content, 'StartEditMode');
                }
                if (Object.prototype.hasOwnProperty.call(this.content, 'MediaKind')) {
                    this.$delete(this.content, 'MediaKind');
                }
            }
            if (this.content.Type === 1) {
                const imageUpload = await this.uploadFiles().catch((error) => {
                    console.log(error);
                    const errorMsg = {
                        Message: this.$t('messages.imageUploadError'),
                        Details: '',
                    };
                    if (
                        error.response &&
                        error.response.data &&
                        error.response.data.message === 'Request Entity Too Large'
                    ) {
                        errorMsg.Message = this.$t('messages.imageUploadSizeError');
                    }
                    EventBus.$emit('ERROR', errorMsg);
                });
                const imageURLs = imageUpload ? imageUpload.map((response) => response.data.url) : [];
                if (this.content.Images && this.content.Images.length > 0) {
                    this.content.Images = this.content.Images.concat(imageURLs);
                } else {
                    this.content.Images = imageURLs;
                }
                this.loading = false;
            }

            this.isEditMode = false;
            if (this.content.StartEditMode) {
                this.content.StartEditMode = false;
            }
            this.$emit('save', this.content);
        },
        discardChanges() {
            this.isEditMode = false;
            // restore original content
            this.content = this.content?.Type === 3 ? cloneDeep(this.originalContent) : this.originalContent;
            this.aspectratio = this.originalContent?.Options?.aspectratio || 'landscape';
            this.backgroundcolor = this.originalContent?.Options?.backgroundcolor || null;
            if (!this.content.Content && get(this.content, 'Images', []).length === 0 && this.content.StartEditMode) {
                this.deleteSection(this.content);
            }
        },
        editSection() {
            if (!this.supportsInlineEditing) {
                return;
            }
            if (this.content?.Type === 3) {
                this.mediaKind = getAudioProvider(this.content.Content) ? 'audio' : 'video';
            }
            this.isEditMode = true;
            if (this.content?.Type === 3) {
                this.focusMediaInput();
            }
        },
        deleteSection(section: any) {
            this.$emit('delete', section);
        },
        moveSectionDown(section: any) {
            this.$emit('down', section);
        },
        moveSectionUp(section: any) {
            this.$emit('up', section);
        },
        createSectionBelow(type: string) {
            this.$emit('add', type);
        },
        handleFileSelect(file: any) {
            this.candidateImages.push(file);
        },

        uploadFiles() {
            return new Promise((resolve, reject) => {
                // return null if no files
                if (!this.candidateImages || !Array.isArray(this.candidateImages) || this.candidateImages.length === 0)
                    return resolve(null);

                // upload all images and return the urls
                const promises = this.candidateImages.map(async (file) => {
                    // only upload if a file is present
                    const data = await createImageUploadFormData(file.file);
                    return axios.post('/upload/image/content-section', data, {
                        withCredentials: true,
                    });
                });

                Promise.all(promises)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error);
                    });
            });
        },
    },
};
